import React from 'react';
import { ChevronDown } from 'lucide-react';

const Select = React.forwardRef(({ className = '', children, ...props }, ref) => {
  return (
    <div className="relative w-full">
      <select
        ref={ref}
        className={`w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-[13px] text-gray-900 appearance-none focus:outline-none focus:ring-2 focus:ring-tenant-primary/20 focus:border-tenant-primary transition-colors ${className}`}
        {...props}
      >
        {children}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
        <ChevronDown size={16} strokeWidth={2} />
      </div>
    </div>
  );
});

Select.displayName = 'Select';

export default Select;
